var map = {
	"./Group 22302.png": 1358,
	"./avatar-christmas.webp": 1359,
	"./bottom-bg-christmas.webp": 1360,
	"./btn-active.png": 1361,
	"./content-deco-1.webp": 1362,
	"./content-deco-2.webp": 1363,
	"./content-deco-3.webp": 1364,
	"./content-deco-4.webp": 1365,
	"./deco-3.webp": 1366,
	"./deposit-icon.webp": 1367,
	"./home-icon-active.webp": 1368,
	"./home-icon.webp": 1369,
	"./live-icon-active.webp": 1370,
	"./live-icon.webp": 1371,
	"./master-bg.jpg": 1372,
	"./master-bg.webp": 1373,
	"./me-icon-active.webp": 1374,
	"./me-icon.webp": 1375,
	"./platform.png": 1376,
	"./platform.webp": 1377,
	"./promos-icon-active.webp": 1378,
	"./promos-icon.webp": 1379,
	"./promos.webp": 1380,
	"./service-christmas.webp": 1381,
	"./snowman.webp": 1382,
	"./sponsor-icon-active.webp": 1383,
	"./sponsor-icon.webp": 1384,
	"./title-deco-left.webp": 1385,
	"./title-deco-right.webp": 1386,
	"./tree.webp": 1387,
	"./vip-icon.webp": 1388,
	"./vip.webp": 1389,
	"./withdraw-icon.webp": 1390,
	"./wwr-img.webp": 1391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;